export default __webpack_public_path__ + "static/media/Group1223.e920a138.svg";